import React, { useEffect, useState } from "react";
import { Database } from "../../config/config.js";
import { TextField, Typography, Select, MenuItem } from "@material-ui/core";
import "../../Style/Forms.css";

const Inmobiliario = (props) => {
  const [tipoInmobiliario, setTipoInmobiliario] = useState([]);
  const [listaInmuebleProvincial, setListaInmuebleProvincial] = useState([])
  const [cantidadInmobiliarios, setCantidadInmobiliarios] = useState([]);
  const [formValuacionEstimada, setFormValuacionEstimada] = useState([]);
  const [formInmobiliarioProvincial, setFormInmobiliarioProvincial] = useState({});
  const [contribucionGasLuz, setContribucionGasLuz] = useState({});


  useEffect(() => {
    api();
    return () => {
      setCantidadInmobiliarios([])
    }
  }, []);


  const api = async () => {
    apiInmuebleProvincial()
    apiTipoInmobiliario()
    
  };


  const apiInmuebleProvincial = async () =>{
    let listInmuebleProvincial = [];
    await Database.collection("InmuebleProvincial")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          listInmuebleProvincial.push(doc.data());
        });
      });
      setListaInmuebleProvincial(listInmuebleProvincial)

  }


  const handleChange = (event) => {
    let cantInmobiliarios = event.target.value
    let arrayCantidadInmobiliarios = Array.from({ length: cantInmobiliarios }, (v, i) => i)
    setCantidadInmobiliarios(arrayCantidadInmobiliarios)
  }



  const apiTipoInmobiliario = async () => {
    let listTipoViviendas = [];
    await Database.collection("TipoVivienda")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          listTipoViviendas.push(doc.data());
        });
      });
    setTipoInmobiliario(listTipoViviendas);
  }


  const onStatusChangeValuacionEstimada = (property) => ({ target: { value } }) => {
    calculoValuacionEstimada(value, property)

  };

  const calculoValuacionEstimada = async (valuacionEstimada, property) => {
    let newValuacionEstimada = { ...formValuacionEstimada };
    let newInmobiliarioProvincial = { ...formInmobiliarioProvincial };
    let inmobiliarioProvincial = []
    listaInmuebleProvincial.forEach(element => 
      {
        if (valuacionEstimada >= element.De && valuacionEstimada < element.Hasta) {
        inmobiliarioProvincial = element
        return
      }
      }
    );
    let impuestoProvincial = (inmobiliarioProvincial.Fijo + (inmobiliarioProvincial.Porcentaje) * (valuacionEstimada - inmobiliarioProvincial.Excedente)) * 1.25
    newValuacionEstimada[property] = valuacionEstimada
    newInmobiliarioProvincial[property] = impuestoProvincial
    setFormValuacionEstimada(newValuacionEstimada);
    setFormInmobiliarioProvincial(newInmobiliarioProvincial)
    props.inmobiliarioProvincial(newInmobiliarioProvincial)
  }


  const onStatusChangeTipoInmobiliario = (property) => ({ target: { value } }) => {
    let newFormData = { ...contribucionGasLuz };
    let newContribucionGasLuz = (tipoInmobiliario[value].luz + tipoInmobiliario[value].gas) * 12
    newFormData[property] = newContribucionGasLuz;
    setContribucionGasLuz(newFormData);
    props.contribucionGasLuz(newFormData)
  };




  return (
    <div className="Ingresos">
      <div className="Ingresos-Title Title">
        <Typography className="Ingresos-Title__Typography">
          Inmobiliario
        </Typography>
        <Typography className="Ingresos-Subtitle__Typography">Los datos aquí requeridos pueden buscarse en el cedulón del año anterior.</Typography>
      </div>
      <div className="Ingresos_Content">
        <Typography className="Ingresos-Subtitle__Typography">
          Cantidad de Inmuebles
        </Typography>
        <Select
          className="Ingresos__Select Ingresos__Select--Vehiculo"
          defaultValue={0}
          onChange={handleChange}
          inputProps={{
            name: "Tipo de Actividad",
            id: "age-native-simple",
          }}
        >
          <MenuItem value={0} >
            Seleccione la Cantidad
          </MenuItem>
          <MenuItem key={1} value={1}>1</MenuItem>
          <MenuItem key={2} value={2}>2</MenuItem>
          <MenuItem key={3} value={3}>3</MenuItem>
          <MenuItem key={4} value={4}>4</MenuItem>
          <MenuItem key={5} value={5}>5</MenuItem>
        </Select>
      </div>
      {!!cantidadInmobiliarios && cantidadInmobiliarios.length > 0 && cantidadInmobiliarios.map((inmobiliario, index) => (
        <div key={index} className="Ingresos_Content Content_Inmobiliario">
          <div className="Ingresos_Content Block">
            <Typography title="Base imponible en $" className="Ingresos-Subtitle__Typography">
              Valuación Estimada {inmobiliario + 1}
            </Typography>
            <TextField
              onChange={onStatusChangeValuacionEstimada(index)}
              className="Ingresos__TextField"
              id="standard-textarea"
              placeholder="Ingrese valor"
              type="number"
            />
          </div>
          <div className="Ingresos_Content Tipo__Inmobiliario">
            <Typography className="Ingresos-Subtitle__Typography">Tipo {inmobiliario + 1}</Typography>
            <Select
              className="Ingresos__Select"
              defaultValue="DEFAULT"
              onChange={onStatusChangeTipoInmobiliario(index)}
              inputProps={{
                name: "Seleccione un tipo",
                id: "age-native-simple",
              }}
            >
              <MenuItem value="DEFAULT" hidden >
                Seleccione un tipo
        </MenuItem>
              {!!tipoInmobiliario && tipoInmobiliario.length > 0 &&
                tipoInmobiliario.map((tipo, index) => (
                  <MenuItem key={index} value={index}>
                    {tipo.Tipo}
                  </MenuItem>
                ))}
            </Select>
          </div>



        </div>
      ))}



    </div>
  );
};

export default Inmobiliario;
